type SortOrder = 'asc' | 'desc';

export const sortByDate = <T>(array: T[], getDate: (item: T) => string, order: SortOrder = 'desc'): T[] => {
  return [...array].sort((a, b) => {
    const timeA = new Date(getDate(a)).getTime();
    const timeB = new Date(getDate(b)).getTime();
    return order === 'asc' ? timeA - timeB : timeB - timeA;
  });
};
